$(document).ready(function () {

  $(window).trigger('resize.boxHeightCalc');

  //Slick Slider Inizializing

  $('.slick-slider').slick({
    slidesToShow: 1,
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3500,
    pauseOnDotsHover: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    infinite: true,
    speed: 500
  });

  //Masonry
  function initializeGrid() {
    var that = this;
    initMasonry(that);
    //Reinitialize masonry inside each panel after the relative tab link is clicked -
    $('a[data-toggle=tab]').each(function () {
      var $this = $(this);
      $this.on('shown.bs.tab', function () {
        initMasonry(that)
      });
    });
  }
  function initMasonry(that) {
    $(that).masonry({
      itemSelector: '.grid-item',
      columnWidth: '.grid-sizer',
      percentPosition: true,
      gutter: 16
    });
  }

  $('.grid').each(function () {
    var grid = $(this);
    grid.imagesLoaded(function () {
      initializeGrid.call(grid);
    });
  });

  //Collapse Element

  var collapseItem = $('.collapse-team');

  collapseItem.on('show.bs.collapse', paddingOn).on('show.bs.collapse', collapseSiblings);
  collapseItem.on('hide.bs.collapse', paddingOff);

  function paddingOn(e) {

    var card = $(this).parents('.position-static'),
      collapse = $(this),
      contentHeight = collapse.outerHeight();

    card.css('padding-bottom', contentHeight).addClass('active');

  }

  function paddingOff(e) {

    var card = $(this).parents('.position-static'),
      collapse = $(this),
      contentHeight = collapse.outerHeight();

    card.css('padding-bottom', 16).removeClass('active');

  }

  function collapseSiblings(e) {

    var siblings = $(this).parents('.position-static').siblings('.position-static').find('.collapse-team');

    siblings.collapse('hide');

  }

  //

  // Artist Filter
  $('#artist-filter a').on('click', function () {

    var $filter = $(this).attr('data-filter'),
      $value = $(this).text();

    $(this).addClass('active');
    $(this).parent('.nav-item').siblings().children('.nav-link').removeClass('active');

    $(this).parents('.dropdown').find('.btn-outline-primary').text($value);

    if ($filter === 'all') {
      // $('.js-filter').removeClass('is-hidden');
      // $( '.js-filter' ).show('fast');
      $('.js-filter').fadeIn(500);
    } else {
      // $('.js-filter').addClass('is-hidden');
      // $( '.js-filter' ).hide('fast');
      $('.js-filter').hide();
      // $('.js-filter[data-filter*="' + $filter + '"]').removeClass('is-hidden');
      // $( '.js-filter[data-filter=' + $filter + ']' ).show('fast');
      $('.js-filter[data-filter*=' + $filter + ']').fadeIn(500);
    }

  });

});


$(window).on('resize.boxHeightCalc', function () {
  //Card Heights

  if ($(window).width() > 767) {

    var cardRow = $('.card-row'),
      maxHeight = 0;

    cardRow.each(function () {
      var card = $(this).find('.card');

      card.each(function () {
        if ($(this).height() > maxHeight) {
          maxHeight = $(this).height();
        }
      });

      card.height(maxHeight);
    });

  }
});

/**
 * Declare fancybox
 */
$('[data-fancybox]').fancybox({
  iframe: {
    preload: false
  }
});

/**
 * Make tabs of artists linkable
 */
$(document).ready(() => {
  let url = location.href.replace(/\/$/, "");

  if (location.hash) {
    const hash = url.split("#");
    $('#tabNavigation a[href="#' + hash[1] + '"]').tab("show");
    url = location.href.replace(/\/#/, "#");
    history.replaceState(null, null, url);
    setTimeout(() => {
      $(window).scrollTop(0);
    }, 400);
  }

  $('a[data-toggle="tab"]').on("click", function () {

    /**
     * Pause all videos on this page.
     * This is needed to prevent videos from ongoing playing when tab is switched.
     */
    callPlayer('pauseVideo', 'youtube-nocookie.com');

    let newUrl;
    const hash = $(this).attr("href");
    if (hash == "#about") {
      newUrl = url.split("#")[0];
    } else {
      newUrl = url.split("#")[0] + hash;
    }
    // newUrl += "/";
    history.replaceState(null, null, newUrl);
  });
});

/**
 * Hide and show cropped text
 */
$('body').delegate('.jsShowOverflowContent', 'click', function () {
  $(this).hide();
  $('.overflow-content, .jsTextBodylink').hide();
  $('.jsTextBodyFull').addClass('show-content');
  return false;
});

/**
 * Control embeded videos
 *
 * @param func What to do with the video (e.g. "pauseVideo", "stopVideo" or "playVideo")
 * @param url String to check. The url of the iframe must match.
 * @param args
 */
function callPlayer(func, url, args) {
  var iframes = document.getElementsByTagName('iframe');
  for (var i = 0; i < iframes.length; ++i) {
    if (iframes[i]) {
      var src = iframes[i].getAttribute('src');
      if (src) {
        if (src.indexOf(url) !== -1) {
          iframes[i].contentWindow.postMessage(JSON.stringify({
            'event': 'command',
            'func': func,
            'args': args || []
          }), "*");
        }
      }
    }
  }
}
